
import PersonalDataForm from "../../forms/shared/PersonalDataForm";
import AddressDataForm, { AddressType } from "../../forms/shared/AddressDataForm";
import VocationalTraningForm, {
  VocationalTraningFormItem,
} from "../../forms/shared/VocationalTraningForm";
import AcademicDegreeForm, {
  AcademicDegreeFormItem,
} from "../../forms/shared/AcademicDegreeForm";
import Professional from "../../models/Professional";
import FormFieldBase from "../../forms/FormFieldBase";
import { FieldAttachment } from "../../forms/FormFieldAttachmentBase";
import RefusalPresentVaccineForm, { RefusalPresentVaccineItem } from "../../forms/shared/termsDeclarations/RefusalPresentVaccineForm";
import PersonalAddressDataForm from "../../forms/multiprofissional/PersonalAddressDataForm";
import { MultiprofissionalStepForm } from "../../config/MultiprofissionalStepForm";
import AttachmentForm from "../../forms/multiprofissional/AttachmentForm";
import BusinessDataForm from "../../forms/shared/BusinessForm";
import TermsDeclarationsForm from "../../forms/multiprofissional/TermsDeclarationsForm";
import GuideForm from "../../forms/shared/GuideForm";
import ReducerBase, { SubTypeAttachment } from "./ReducerBase";
import FormBase from "../../forms/FormBase";

export interface IMultiprofissionalState {
  GuideForm: GuideForm;
  PersonalDataForm: PersonalDataForm;
  AddressDataForm: AddressDataForm;
  VocationalTraningForm: VocationalTraningForm;
  AcademicDegreeForm: AcademicDegreeForm;
  PersonalAddressDataForm: PersonalAddressDataForm;
  AttachmentForm: AttachmentForm;
  BusinessDataForm: BusinessDataForm;
  BusinessAddressDataForm: AddressDataForm;
  TermsDeclarationsForm: TermsDeclarationsForm;
  RefusalPresentVaccineForm: RefusalPresentVaccineForm;
  CurrentStep: number;
  MessageErrorToGoStep: string[];
  Loading: boolean;
  Professional: Professional;
  Protocol: string;
}

interface IUpdateForm {
  type: "UPDATE_FORM";
  payload: {
    form: FormBase;
    name: string;
    value: any;
  };
}

interface IUpdateFormAttachment {
  type: "UPDATE_FORM_ATTACHMENT";
  payload: {
    form: FormBase;
    name: string;
    value: FieldAttachment;
    errorMessage?: string;
    id?: string;
    loading?: boolean;
    subType: SubTypeAttachment;
  };
}

interface IUpdateFormRefusalPresentVaccineItemData {
  type: "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM";
  payload: {
    form: FormBase;
    name: string;
    value: any;
    item: RefusalPresentVaccineItem;
  };
}

interface ICRUDFormVocationData {
  type: "CRUD_FORM_VOCATION_TRANING";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: VocationalTraningFormItem;
  };
}

interface ICRUDFormAcademicDegreeData {
  type: "CRUD_FORM_ACADEMIC_DEGREE";
  payload: {
    subType: "InsertOrUpdate" | "Delete" | "Cancel" | "Edit";
    item?: AcademicDegreeFormItem;
  };
}

interface IGoToNextStep {
  type: "GO_TO_NEXT_STEP";
  payload: { messagesError: string[] };
}

interface IGoToBackStep {
  type: "GO_TO_BACK_STEP";
}

interface IProcessingInfo {
  type: "LOADING";
  payload: { processing: boolean };
}
interface ISetProfessionalId {
  type: "SET_PROFESSIONAL";
  payload: {
    response: any;
  };
}
interface ISetProtocol {
  type: "SET_PROTOCOL";
  payload: {
    response: any;
  };
}

interface IResetState {
  type: "RESET_STATE";
}

export type Actions =
  | IUpdateForm
  | IGoToNextStep
  | IGoToBackStep
  | ICRUDFormVocationData
  | ICRUDFormAcademicDegreeData
  | IUpdateFormRefusalPresentVaccineItemData
  | ISetProfessionalId
  | ISetProtocol
  | IProcessingInfo
  | IUpdateFormAttachment
  | IResetState;

export const initialState: IMultiprofissionalState = {
  GuideForm: GuideForm.NewInstance(),
  PersonalDataForm: PersonalDataForm.NewInstance(),
  AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
  VocationalTraningForm: VocationalTraningForm.NewInstance(),
  AcademicDegreeForm: AcademicDegreeForm.NewInstance(),
  PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
  AttachmentForm: AttachmentForm.NewInstance(),
  BusinessDataForm: BusinessDataForm.NewInstance(),
  BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
  TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
  RefusalPresentVaccineForm: RefusalPresentVaccineForm.NewInstance(),
  CurrentStep: 1,
  MessageErrorToGoStep: [],
  Loading: false,
  Professional: Professional.NewInstance(),
  Protocol: "",
};

export const reducer = (state: IMultiprofissionalState, action: Actions) => {
  switch (action.type) {
    case "UPDATE_FORM": {
      const { form, name, value } = action.payload;

      (form.GetFieldByName(name) as FormFieldBase).Value = value;
      (form.GetFieldByName(name) as FormFieldBase).InputChange(value);
      (form.GetFieldByName(name) as FormFieldBase).ValidateField();

      return { ...state };
    }

    case "UPDATE_FORM_ATTACHMENT": {
      const { form, name, value, subType, id, errorMessage, loading } = action.payload;

      ReducerBase.updateFileActions(form, name, value, subType, errorMessage, id, loading);


      return { ...state };
    }

    case "SET_PROFESSIONAL": {
      const { response } = action.payload;

      let professional = new Professional(response.encriptId, response.name);

      return { ...state, Professional: professional };
    }
    case "SET_PROTOCOL": {
      const { response } = action.payload;

      return { ...state, Protocol: response.protocol };
    }

    case "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM": {
      const { name, value, item } = action.payload;

      switch (name) {
        case "Checked":
          item.Checked.Value = value;
          break;
        case "ApplyDate":
          item.ApplyDate.Value = value;
          break;
        case "Reason":
          item.Reason.Value = value;
          break;

        default:
          break;
      }

      return { ...state };
    }

    case "CRUD_FORM_VOCATION_TRANING": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.VocationalTraningForm.AddOrUpdateVocationalTraningFormItem();
      } else if (subType === "Edit") {
        state.VocationalTraningForm.EditVocationalTraningFormItem(
          item?.Id || 0
        );
      } else if (subType === "Delete") {
        state.VocationalTraningForm.RemoveVocationalTraningFormItem(
          item?.Id || 0
        );
      } else if (subType === "Cancel") {
        state.VocationalTraningForm.ResetForm();
      }

      return { ...state };
    }

    case "CRUD_FORM_ACADEMIC_DEGREE": {
      const { subType, item } = action.payload;

      if (subType === "InsertOrUpdate") {
        state.AcademicDegreeForm.AddOrUpdateAcademicDegreeFormItem();
      } else if (subType === "Edit") {
        state.AcademicDegreeForm.EditAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Delete") {
        state.AcademicDegreeForm.RemoveAcademicDegreeFormItem(item?.Id || 0);
      } else if (subType === "Cancel") {
        state.AcademicDegreeForm.ResetForm();
      }

      return { ...state };
    }

    case "GO_TO_NEXT_STEP": {
      const { messagesError } = action.payload;

      //Se houver mensagens de erro, não pode avançar a etapa
      if (messagesError.length === 0) {
        if (state.CurrentStep < MultiprofissionalStepForm.length) {
          return {
            ...state,
            CurrentStep: state.CurrentStep + 1,
            MessageErrorToGoStep: [],
          };
        }
      } else {
        return { ...state, MessageErrorToGoStep: messagesError };
      }

      return { ...state };
    }

    case "GO_TO_BACK_STEP":
      if (state.CurrentStep > 1) {
        return {
          ...state,
          CurrentStep: state.CurrentStep - 1,
          MessageErrorToGoStep: [],
        };
      }
      return { ...state };

    case "LOADING":
      const { processing: loading } = action.payload;

      return { ...state, Loading: loading };

    case "RESET_STATE":

      return {
        ...state,
        GuideForm: GuideForm.NewInstance(),
        PersonalDataForm: PersonalDataForm.NewInstance(),
        AddressDataForm: AddressDataForm.NewInstance(AddressType.PERSONAL),
        VocationalTraningForm: VocationalTraningForm.NewInstance(),
        AcademicDegreeForm: AcademicDegreeForm.NewInstance(),
        PersonalAddressDataForm: PersonalAddressDataForm.NewInstance(),
        AttachmentForm: AttachmentForm.NewInstance(),
        BusinessDataForm: BusinessDataForm.NewInstance(),
        BusinessAddressDataForm: AddressDataForm.NewInstance(AddressType.BUSINESS),
        TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
        RefusalPresentVaccineForm: RefusalPresentVaccineForm.NewInstance(),
        CurrentStep: 1,
        MessageErrorToGoStep: [],
        Loading: false,
        Professional: Professional.NewInstance(),
        Protocol: "",
      };

    default:
      return { ...state };
  }
};

export function getStateFormPropertyByName(
  name: string,
  state: IMultiprofissionalState
): any {
  switch (name) {
    case "GuideForm":
      return state.GuideForm;
    case "PersonalDataForm":
      return state.PersonalDataForm;
    case "AddressDataForm":
      return state.AddressDataForm;
    case "VocationalTraningForm":
      return state.VocationalTraningForm;
    case "AcademicDegreeForm":
      return state.AcademicDegreeForm;
    case "PersonalAddressDataForm":
      return state.PersonalAddressDataForm;
    case "AttachmentForm":
      return state.AttachmentForm;
    case "BusinessDataForm":
      return state.BusinessDataForm;
    case "BusinessAddressDataForm":
      return state.BusinessAddressDataForm;
    case "TermsDeclarationsForm":
      return state.TermsDeclarationsForm;
    case "RefusalPresentVaccineForm":
      return state.RefusalPresentVaccineForm;
    default:
      console.error(`O Formulário ${name} não está mapeando no reducer`);
      break;
  }
}
